import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import type { TooltipProps } from "reactstrap";
import "./ResultsDropdown.css";
import * as filterResultPresetConst from "../../constants/filterResultPresetConst";

type Props = {
  commonTooltipProps: Pick<TooltipProps, "placement" | "container" | "modifiers">;
  tooltipOpen: { save: boolean; clear: boolean; load: boolean; seasons: boolean; display: boolean };
  toggleTooltip: (k: keyof Props["tooltipOpen"]) => void;
  isOpen: boolean;
  toggle: () => void;
  selectedResult: string;
  presetNames: string[];
  onSelect: (name: string) => void;
};

export function ResultsDropdown({
  commonTooltipProps,
  tooltipOpen,
  toggleTooltip,
  isOpen,
  toggle,
  selectedResult,
  presetNames,
  onSelect,
}: Props) {
  return (
    <>
      <Dropdown isOpen={isOpen} toggle={toggle} size="sm" className="w-100">
        <DropdownToggle
          caret
          outline
          id="btnResultsDropdownToggle"
          aria-label="Select Results Group"
          className="border-0 shadow-none btn-hover-10 text-truncate text-uppercase text-left w-100 d-flex justify-content-between align-items-center"
        >
          <span className="text-truncate text-capitalize results-dropdown-toggle">
            {selectedResult}
          </span>
        </DropdownToggle>

        <DropdownMenu className="bg-dark text-white border-0">
          <DropdownItem
            className={`text-white d-flex justify-content-between align-items-center results-dropdown-item ${
              selectedResult === filterResultPresetConst.Clear ? "active" : ""
            }`}
            onClick={() => onSelect(filterResultPresetConst.Clear)}
            disabled={selectedResult === filterResultPresetConst.Clear}
            role="menuitem"
            id="btnResultsDropdownClear"
          >
            <span>{filterResultPresetConst.Clear}</span>
            <FontAwesomeIcon
              icon={faCheck}
              className={`ml-3 results-check-${selectedResult === filterResultPresetConst.Clear ? "visible" : "hidden"}`}
            />
          </DropdownItem>

          <DropdownItem
            className={`text-white d-flex justify-content-between align-items-center results-dropdown-item ${
              selectedResult === filterResultPresetConst.Defaults ? "active" : ""
            }`}
            onClick={() => onSelect(filterResultPresetConst.Defaults)}
            disabled={selectedResult === filterResultPresetConst.Defaults}
            role="menuitem"
            id="btnResultsDropdownDefaults"
          >
            <span>{filterResultPresetConst.Defaults}</span>
            <FontAwesomeIcon
              icon={faCheck}
              className={`ml-3 results-check-${selectedResult === filterResultPresetConst.Defaults ? "visible" : "hidden"}`}
            />
          </DropdownItem>

          {selectedResult === filterResultPresetConst.CustomUnsaved && (
            <>
              <DropdownItem
                className={`text-white d-flex justify-content-between align-items-center results-dropdown-item ${
                  selectedResult === filterResultPresetConst.CustomUnsaved ? "active" : ""
                }`}
                onClick={() => {}}
                disabled={true}
                role="menuitem"
                id="btnResultsDropdownCustomUnsaved"
              >
                <span className="font-italic text-muted">
                  {filterResultPresetConst.CustomUnsaved}
                </span>
                <FontAwesomeIcon
                  icon={faCheck}
                  className={`ml-3 results-check-${selectedResult === filterResultPresetConst.CustomUnsaved ? "visible" : "hidden"}`}
                />
              </DropdownItem>
            </>
          )}

          <DropdownItem
            className={`text-white d-flex justify-content-between align-items-center results-dropdown-item ${
              selectedResult === filterResultPresetConst.Custom ? "active" : ""
            }`}
            onClick={() => onSelect(filterResultPresetConst.Custom)}
            disabled={selectedResult === filterResultPresetConst.Custom}
            role="menuitem"
            id="btnResultsDropdownCustom"
          >
            <span>{filterResultPresetConst.Custom}</span>
            <FontAwesomeIcon
              icon={faCheck}
              className={`ml-3 results-check-${selectedResult === filterResultPresetConst.Custom ? "visible" : "hidden"}`}
            />
          </DropdownItem>

          {presetNames.length > 0 && (
            <>
              {presetNames.map((name, i) => (
                <DropdownItem
                  key={name}
                  className={`text-white d-flex justify-content-between align-items-center results-dropdown-item ${
                    selectedResult === name ? "active" : ""
                  }`}
                  onClick={() => onSelect(name)}
                  disabled={selectedResult === name}
                  role="menuitem"
                  id={`btnResultsDropdownItem${i}`}
                >
                  <span>{name}</span>
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={`ml-3 results-check-${selectedResult === name ? "visible" : "hidden"}`}
                  />
                </DropdownItem>
              ))}
            </>
          )}
        </DropdownMenu>
      </Dropdown>
      <Tooltip
        isOpen={tooltipOpen.load}
        target="btnResultsDropdownToggle"
        toggle={() => toggleTooltip("load")}
        {...commonTooltipProps}
      >
        Select a results group
      </Tooltip>
    </>
  );
}
